'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _responderSelectors = require('conversations-core/selectors/responderSelectors');

var _ChatFeed = require('conversations-core/components/chat/ChatFeed');

var _ChatFeed2 = _interopRequireDefault(_ChatFeed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChatFeedContainer(props) {
  return _react2.default.createElement(_ChatFeed2.default, props);
}

ChatFeedContainer.propTypes = {
  responders: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    responders: (0, _responderSelectors.getResponders)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ChatFeedContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/containers/ChatFeedContainer.js
// module id = 286
// module chunks = 0 1